import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseText',
  props: {
    maxWidth: null,
    minWidth: null,
    lineClamp: null,
    isEllipsis: { type: Boolean },
    isUnderline: { type: Boolean },
    customClass: null,
    isStrikethrough: { type: Boolean },
    isAnywhereWrap: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    maxWidth?: string,
    minWidth?: string,
    lineClamp?: number | string,
    isEllipsis?: boolean,
    isUnderline?: boolean,
    customClass?: string,
    isStrikethrough?: boolean,
    isAnywhereWrap?: boolean,
}



return { __sfc: true,props }
}

})